// src/components/BottomNavigation.js
import React from 'react';
import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { FaHome, FaUser, FaClipboardList, FaBox, FaShoppingCart } from 'react-icons/fa';

const BottomNavigation = () => {
  return (
    <Nav className="navbar fixed-bottom navbar-dark bg-dark justify-content-around">
      <NavLink to="/" exact className="nav-link" activeClassName="active">
        <FaHome className="h-6 w-6" />
        <span className="d-block text-xs">Dashboard</span>
      </NavLink>
      <NavLink to="/prospectos" className="nav-link" activeClassName="active">
        <FaClipboardList className="h-6 w-6" />
        <span className="d-block text-xs">Prospectos</span>
      </NavLink>
      <NavLink to="/clientes" className="nav-link" activeClassName="active">
        <FaUser className="h-6 w-6" />
        <span className="d-block text-xs">Clientes</span>
      </NavLink>
      <NavLink to="/pedido" className="nav-link" activeClassName="active">
        <FaShoppingCart className="h-6 w-6" />
        <span className="d-block text-xs">Pedido</span>
      </NavLink>
      <NavLink to="/productos" className="nav-link" activeClassName="active">
        <FaBox className="h-6 w-6" />
        <span className="d-block text-xs">Productos</span>
      </NavLink>
    </Nav>
  );
};

export default BottomNavigation;
